import React, { Component, Fragment } from 'react';
import { ButtonTheme, ModalType } from '@philips-internal/oswald-ui-constants';
import { isEmptyArrayOrObject, isEqualShallow, noop } from '@philips-internal/oswald-ui-utils';
import { ReactComponent as RemoveIcon } from '../../../../resources/assets/components/cancel-md-light.svg';
import { FilterService } from '../../../services/filter-service/filter-service.js';
import { ActionStyle } from '../../action/action-constants.js';
import { Field } from '../../field/field.js';
import { Form } from '../../form/form.js';
import { HeadingContext } from '../../heading/components/heading-context/heading-context.js';
import { Input } from '../../input/input.js';
import { Modal } from '../../modal/modal.js';
import { compareRecordSymbol } from '../filter-symbol.js';
class FilterForm extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            internalRecord: {},
            savingFilter: false,
        };
        this.onOpenSaveFilter = () => {
            this.setState({ savingFilter: true });
        };
        this.onSaveFilter = (event) => {
            const { id } = this.props;
            const { internalRecord: data } = this.state;
            const { name } = event.record;
            const save = () => void FilterService.save(id, { data, name })
                .then(() => this.addContextualBarActions());
            this.setState({ savingFilter: false }, save);
        };
        this.onRemoveSavedFilter = (recordId) => {
            const { id } = this.props;
            void FilterService.remove(id, recordId).then(() => this.addContextualBarActions());
        };
        this.onCancelSaveFilter = () => {
            this.setState({ savingFilter: false });
        };
        this.onLoadSavedFilter = (record) => {
            this.setState({ internalRecord: record });
        };
        this.onFormChange = (event) => {
            const { value } = event;
            this.setState(({ internalRecord }) => ({
                internalRecord: { ...internalRecord, ...value },
            }));
        };
        this.onFormClear = () => {
            this.setState({ internalRecord: {} }, () => {
                const { onClear } = this.props;
                onClear();
            });
        };
    }
    componentDidMount() {
        const { record: internalRecord } = this.props;
        this.setState({ internalRecord });
        this.addContextualBarActions();
    }
    componentDidUpdate(prevProps) {
        const { record } = this.props;
        if (!isEqualShallow(record, prevProps.record)) {
            this.setState({ internalRecord: record });
            return;
        }
        if (!compareRecordSymbol(record, prevProps.record)) {
            this.setState({ internalRecord: record });
        }
    }
    addContextualBarActions() {
        const { id } = this.props;
        if (!FilterService.isConfigured() || !id) {
            return;
        }
        this.context?.addOrUpdateAction({
            buttonTheme: ButtonTheme.QUIET_EMPHASIS,
            className: 'c-filter-form-save-filter',
            enabled: true,
            icon: '/static/assets/components/DLS_PlusSolid.svg',
            id: 'filter-form-save-filter',
            onClick: this.onOpenSaveFilter,
            style: ActionStyle.BUTTON,
            text: 'tws.filter.save-filter',
        });
        this.addSavedFiltersContextualBarAction();
    }
    addSavedFiltersContextualBarAction() {
        const { id } = this.props;
        const savedFiltersAction = {
            buttonTheme: ButtonTheme.QUIET_EMPHASIS,
            id: 'filter-form-saved-filters',
            onClick: noop,
            style: ActionStyle.DROPDOWN,
            text: 'tws.filter.saved-filters',
        };
        const removeFilterSwipeAction = {
            backgroundColor: 'hsl(var(--color-safety-red))',
            icon: React.createElement(RemoveIcon, null),
            key: 'remove-saved-filter',
        };
        void FilterService.load(id)
            .then(filters => {
            const options = filters?.map(filter => ({
                enabled: true,
                id: filter.id,
                onClick: () => this.onLoadSavedFilter(filter.data),
                style: ActionStyle.TEXT,
                swipeActions: [{
                        ...removeFilterSwipeAction,
                        onClick: () => this.onRemoveSavedFilter(filter.id),
                    }],
                text: filter.name,
            }));
            this.context?.addOrUpdateAction({
                ...savedFiltersAction,
                enabled: !isEmptyArrayOrObject(filters),
                options,
            });
        })
            .catch(() => this.context?.addOrUpdateAction({ ...savedFiltersAction, enabled: false }));
    }
    renderSaveFilterModal() {
        const { density } = this.props;
        const { savingFilter } = this.state;
        if (!savingFilter) {
            return null;
        }
        return (React.createElement(Modal, { onClose: this.onCancelSaveFilter, title: "tws.filter.save-filter", type: ModalType.DIALOG },
            React.createElement(Form, { density: density, editing: true, locked: true, onCancel: this.onCancelSaveFilter, onSubmit: this.onSaveFilter, uuid: "fake-uuid" },
                React.createElement(Field, { entry: "name", label: "tws.filter.filter-name", uuid: "fake-uuid", validators: [{ name: 'required', options: {} }], width: 12 },
                    React.createElement(Input, null)))));
    }
    render() {
        const { children, density, onApply, uuid } = this.props;
        const { internalRecord } = this.state;
        if (!children) {
            return null;
        }
        return (React.createElement(Fragment, null,
            this.renderSaveFilterModal(),
            React.createElement(Form, { cancelExpression: "tws.filter.clear-all", data: internalRecord, density: density, editing: true, locked: true, onCancel: this.onFormClear, onChange: this.onFormChange, onSubmit: (event) => onApply(event, false), saveExpression: "tws.filter.apply", uuid: uuid }, children)));
    }
}
FilterForm.contextType = HeadingContext;
export { FilterForm, };
//# sourceMappingURL=filter-form.js.map